<div class="table-wrapper-smaller">
  <div class="table-container">
    <table>
      <thead>
        <tr>
          <th class="icon"></th>
          <th class="string sortable" id="royaltiesGestProdCol2" [appSort]="_royaltiesProductor" data-order="desc" data-name="desPais" (click)="toOrderBy(2)">{{'global.pais' | translate}}
            <div class="sortable-icons">
              <i [ngClass]="getIcon(2)"></i>
            </div>
          </th>
          <th class="string sortable" id="royaltiesGestProdCol3" [appSort]="_royaltiesProductor" data-order="desc" data-name="desProductor" (click)="toOrderBy(3)">{{'gestionRoyalties.productor.table.productor' | translate}}
            <div class="sortable-icons">
              <i [ngClass]="getIcon(3)"></i>
            </div>
          </th>
          <th class="string sortable" id="royaltiesGestProdCol4" [appSort]="_royaltiesProductor" data-order="desc" data-name="desDenominacion" (click)="toOrderBy(4)">{{'gestionRoyalties.productor.table.denominacion' | translate}}
            <div class="sortable-icons">
              <i [ngClass]="getIcon(4)"></i>
            </div>
          </th>
          <th class="string sortable" id="royaltiesGestProdCol5" [appSort]="_royaltiesProductor" data-order="desc" data-name="desMarca" (click)="toOrderBy(5)">{{'gestionRoyalties.productor.table.marca' | translate}}
            <div class="sortable-icons">
              <i [ngClass]="getIcon(5)"></i>
            </div>
          </th>
          <th class="number sortable" id="royaltiesGestProdCol6" [appSort]="_royaltiesProductor" data-order="desc" data-name="sumaSuperficie" (click)="toOrderBy(6)">{{'gestionRoyalties.productor.table.superficie' | translate}} {{ _unidadesMedida ? "(" + _unidadesMedida.superficie.symbol + ")" : "" }}
            <div class="sortable-icons">
              <i [ngClass]="getIcon(6)"></i>
            </div>
          </th>
          <th class="number sortable" id="royaltiesGestProdCol7" [appSort]="_royaltiesProductor" data-order="desc" data-name="calculo_Superficie_Fee" (click)="toOrderBy(7)">{{'gestionRoyalties.productor.table.importe' | translate}} {{ _unidadesMedida ? "(" + _unidadesMedida.divisas.symbol + ")" : "" }}
            <div class="sortable-icons">
              <i [ngClass]="getIcon(7)"></i>
            </div>
          </th>
          <th class="number sortable" id="royaltiesGestProdCol8" [appSort]="_royaltiesProductor" data-order="desc" data-name="sumaNPlantas" (click)="toOrderBy(8)">{{'gestionRoyalties.productor.table.plantas' | translate}} {{ _unidadesMedida ? "(" + _unidadesMedida.nPlantas.symbol + ")" : "" }}
            <div class="sortable-icons">
              <i [ngClass]="getIcon(8)"></i>
            </div>
          </th>
          <th class="number sortable" id="royaltiesGestProdCol9" [appSort]="_royaltiesProductor" data-order="desc" data-name="calculo_NPlantas_Fee" (click)="toOrderBy(9)">{{'gestionRoyalties.productor.table.importe' | translate}} {{ _unidadesMedida ? "(" + _unidadesMedida.divisas.symbol + ")" : "" }}
            <div class="sortable-icons">
              <i [ngClass]="getIcon(9)"></i>
            </div>
          </th>
          <th class="number sortable sortable-bigger" id="royaltiesGestProdCol10" [appSort]="_royaltiesProductor" data-order="desc" data-name="sumaKilos" (click)="toOrderBy(10)">{{'gestionRoyalties.productor.table.pesoProducido' | translate}} {{ _unidadesMedida ? "(" + _unidadesMedida.peso.symbol + ")" : "" }}
            <div class="sortable-icons">
              <i [ngClass]="getIcon(10)"></i>
            </div>
          </th>
          <th class="number sortable" id="royaltiesGestProdCol11" [appSort]="_royaltiesProductor" data-order="desc" data-name="calculo_Kilos_Fee" (click)="toOrderBy(11)">{{'gestionRoyalties.productor.table.importe' | translate}} {{ _unidadesMedida ? "(" + _unidadesMedida.divisas.symbol + ")" : "" }}
            <div class="sortable-icons">
              <i [ngClass]="getIcon(11)"></i>
            </div>
          </th>
          <th class="number sortable" id="royaltiesGestProdCol12" [appSort]="_royaltiesProductor" data-order="desc" data-name="total_Fee" (click)="toOrderBy(12)">{{'gestionRoyalties.productor.table.total' | translate}} {{ _unidadesMedida ? "(" + _unidadesMedida.divisas.symbol + ")" : "" }}
            <div class="sortable-icons">
              <i [ngClass]="getIcon(12)"></i>
            </div>
          </th>
          <th class="multi-actions"></th>
        </tr>
      </thead>
      <tbody *ngFor="let royalty of royalties; let i = index; trackBy: trackByProductorId">
        <tr [ngClass]="{'dropdownInfo': dropdownInfo === i}" (click)="showDetails(i)" style="cursor: pointer;">
          <td class="icon"><i [ngClass]="dropdownInfo === i ? 'fas fa-angle-down fa-sm' : 'fas fa-angle-right fa-sm'"
            title="{{dropdownInfo === i ? ('global.minimizarInfo' | translate) : ('global.masInfo' | translate)}}"></i>
          </td>
          <td class="string">{{royalty.desPais}}</td>
          <td class="string">{{royalty.desProductor}}</td>
          <td class="string">{{royalty.desDenominacion}}</td>
          <td class="string">{{royalty.desMarca}}</td>
          <td class="number">{{royalty.sumaSuperficie | number : '1.2-2' : defaultLanguage}}</td>
          <td class="number">{{royalty.calculo_Superficie_Fee | number : '1.2-2' : defaultLanguage}}</td>
          <td class="number">{{royalty.sumaNPlantas | number : '1.2-2' : defaultLanguage}}</td>
          <td class="number">{{royalty.calculo_NPlantas_Fee | number : '1.2-2' : defaultLanguage}}</td>
          <td class="number">{{royalty.sumaKilos | number : '1.2-2' : defaultLanguage}}</td>
          <td class="number">{{royalty.calculo_Kilos_Fee | number : '1.2-2' : defaultLanguage}}</td>
          <td class="number">{{royalty.total_Fee| number : '1.2-2' : defaultLanguage}}</td>
          <td class="multi-actions">
            <i class="fas fa-stream" app-click-stop-propagation (click)="openTabs(i)" title="{{dropdownSection === i ? ('global.minimizarDetalle' | translate) : ('global.mostrarDetalle' | translate)}}"></i>
            <i class="fas fa-file-pdf" (click)="exportPdf(i)" title="{{'gestionRoyalties.productor.exportPDF' | translate}}"></i>
          </td>
        </tr>
        <tr *ngIf="dropdownInfo === i">
          <td colspan="13">
            <div class="detail">
              <div class="title">{{'global.masInformacion' | translate}}</div>
              <div class="block-inline">
                <label>{{'gestionRoyalties.productor.table.royalty' | translate}} {{'gestionRoyalties.productor.table.superficie' | translate}}</label>
                <p>{{royalty.royalty_Superficie_Fee | number : '1.2-2' : defaultLanguage}} {{ _unidadesMedida.divisas.symbol }}</p>
              </div>
              <div class="block-inline">
                <label>{{'gestionRoyalties.productor.table.royalty' | translate}} {{'gestionRoyalties.productor.table.plantas' | translate}}</label>
                <p>{{royalty.royalty_NPlantas_Fee | number : '1.2-2' : defaultLanguage}} {{ _unidadesMedida.divisas.symbol }}</p>
              </div>
              <div class="block-inline">
                <label>{{'gestionRoyalties.productor.table.royalty' | translate}} {{'gestionRoyalties.productor.table.pesoProducido' | translate}}</label>
                <p>{{royalty.royalty_Kilos_Fee | number : '1.2-2' : defaultLanguage}} {{ _unidadesMedida.divisas.symbol }}</p>
              </div>
            </div>
          </td>
        </tr>
        <tr *ngIf="dropdownSection === i">
          <td colspan="9">
              <section class="tabs">
                  <ul>
                      <li class="active">{{'global.cultivos' | translate}}</li>
                  </ul>
                  <content>
                      <app-roy-cultivos-productor [cultivos]="cultivosProductor" [unidadesMedida]="_unidadesMedida"></app-roy-cultivos-productor>
                  </content>
              </section>
          </td>
        </tr>
      </tbody>
      <tfoot *ngIf="!royalties || (royalties && royalties.length < 1) || _filterEtqApplied">
        <tr *ngIf="!royalties && !_filterEtqApplied || (royalties && royalties.length < 1 && !_filterEtqApplied)">
            <td colspan="13">
                {{'global.noContent' | translate}}
            </td>
        </tr>
        <tr *ngIf="_filterEtqApplied">
          <td colspan="13">
            {{'gestionRoyalties.productor.filterEtqApplied' | translate}}
          </td>
        </tr>
      </tfoot>
    </table>
  </div>
</div>
<app-paginator
        *ngIf="(_royaltiesProductor && _royaltiesProductor.length > 0)"
        [itemsPerPage]="itemsPerPage" [currentPage]="currentPage" [totalItems]="totalItems"
        [visiblePages]="visiblePages" (pageChange)="pageChange($event)"
        (itemsPerPageChange)="itemsPerPageChange($event)"></app-paginator>
